<div class="flex flex-col items-center justify-center w-full min-h-[80vh] gap-4 p-6">
    <!-- Icon -->
    <ng-icon
        hlm
        size="xl"
        name="lucideAlertTriangle"
        [ngClass]="{
            'invalid-color': screenType === WarningScreenType.InvalidUrlScreen || screenType === WarningScreenType.IncorrectTimeScreen,
            'error-color': screenType === WarningScreenType.ErrorScreen,
        }"
    ></ng-icon>

    <!-- Error Title -->
    <div
        hlmEmptyTitle
        class="text-2xl font-normal text-center"
        [ngClass]="{
            'text-dsb-neutral-900': screenType !== WarningScreenType.ErrorScreen,
            'text-theme-primary': screenType === WarningScreenType.ErrorScreen,
        }"
    >
        {{ screenMainTitle }}
    </div>

    <!-- Error Subtext and Actions -->
    <div hlmEmptyDescription>
        <p class="text-2xl font-normal mb-4">{{ screenSubtext }}</p>

        <div class="flex flex-col items-center gap-3">
            <!-- Try Again Button -->
            <button
                *ngIf="isErrorScreen"
                hlmBtn
                class="w-full md:w-auto flex items-center justify-center gap-2"
                (click)="requestAppointmentAgain()"
                [disabled]="isLoading"
            >
                <span>Try again</span>
                <ng-icon *ngIf="isLoading" hlm size="sm" name="lucideLoader" class="inline-block animate-spin" aria-hidden="true"></ng-icon>
            </button>

            <!-- Phone Number Link -->
            <a
                *ngIf="screenType === WarningScreenType.ErrorScreen && phoneNumberExists; else phoneNumberMissing"
                [href]="'tel:' + businessPhoneNumber"
                class="text-primary underline"
            >
                {{ businessPhoneNumber }}
            </a>
            <ng-template #phoneNumberMissing>{{ businessPhoneNumber }}</ng-template>
        </div>
    </div>
</div>
